import React, { Component, Fragment } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import classnames from "classnames";
import OrderInlineDetail from "../../Order/InlineDetail";
import ItemRow from "./ItemRow";
import style from "./OrderQuantityToTradesAssignment.module.scss";
import { Combobox } from "../Order/Field/Field";

class OrderQuantityToTradesAssignment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: {
        currentOrderVersion: null,
      },
      selectedDate: null,
      days: null,
      confirm: {
        enabled: false,
        loading: false,
      },
      error: null,
    };
  }

  componentDidMount() {
    const { order } = this.props;

    if (order.OrderId != 0) {
      // retrieve trades assignment in the order
      //this.state.loadings.distribute = true;

      this.getAssignment(order.OrderId);
    }
  }

  getAssignment = (orderId) => {
    const { fetchOrderQuantityToTradesAssignment } = this.props;

    fetchOrderQuantityToTradesAssignment({ orderId })
      .then((res) => res.response.QuantityToTradesAssignment)
      .then((assignment) => {
        const info = {
          currentOrderVersion: parseInt(assignment.CurrentVersion, 10),
        };

        let selectedDate = null;
        const days = [];
        assignment.Day.forEach((d) => {
          const day = {
            date: d.Date,
            clientQtyToAssign: parseFloat(d.ClientQuantityToAssign),
            propQtyToAssign: parseFloat(d.PropQuantityToAssign),
            tradingQtyToAssign: parseFloat(d.TradingQuantityToAssign),
            errorQtyToAssign: parseFloat(d.ErrorQuantityToAssign),
            leftClientQtyToAssign: parseFloat(d.ClientQuantityToAssign),
            leftPropQtyToAssign: parseFloat(d.PropQuantityToAssign),
            leftTradingQtyToAssign: parseFloat(d.TradingQuantityToAssign),
            leftErrorQtyToAssign: parseFloat(d.ErrorQuantityToAssign),
            trades: [],
          };

          day.trades = d.Trades.map((t) => {
            const trade = {
              tradeId: parseInt(t.TradeId, 10),
              enabled: !t.AssignedQuantityIsFixed,
              quantity: parseFloat(t.Quantity),
              assignedClientQty: parseFloat(t.AssignedClientQuantity),
              assignedPropQty: parseFloat(t.AssignedPropQuantity),
              assignedTradingQty: parseFloat(t.AssignedTradingQuantity),
              assignedErrorQty: parseFloat(t.AssignedErrorQuantity),
              info: {
                TradeStatus: t.TradeInfo.TradeStatus,
                TradeSide: t.TradeInfo.TradeSide,
                TradeOpenClose: t.TradeInfo.TradeOpenClose,
                TradeAssetTicker: t.TradeInfo.TradeAssetTicker,
                TradeAssetISIN: t.TradeInfo.TradeAssetISIN,
                TradeAssetClassForm: t.TradeInfo.TradeAssetClassForm,
                TradeSettleCurrencyISO: t.TradeInfo.TradeSettleCurrencyISO,
                TradeQuantity: parseFloat(t.TradeInfo.TradeQuantity),
                TradeAvgPrice: parseFloat(t.TradeInfo.TradeAvgPrice),
              },
            };

            day.leftClientQtyToAssign -= trade.assignedClientQty;
            day.leftPropQtyToAssign -= trade.assignedPropQty;
            day.leftTradingQtyToAssign -= trade.assignedTradingQty;
            day.leftErrorQtyToAssign -= trade.assignedErrorQty;

            return trade;
          });

          day.trades.sort((a, b) => a.tradeId - b.tradeId);

          days.push(day);

          if (selectedDate == null && d.Auxiliar.HasNotBookedTrades) {
            selectedDate = day.date;
          }
        });

        if (!selectedDate && days.length > 0) {
          selectedDate = days[0].date;
        }

        this.setState({
          info,
          selectedDate,
          days,
        });
      });
  };

  onToggle = () => {
    const { onToggle } = this.props;
    onToggle();
  };

  changeItem = (itemId, name, value) => {
    const { days, selectedDate } = this.state;

    const day = days.find((d) => d.date === selectedDate);
    const trade = day.trades.find((t) => t.tradeId === itemId);

    trade[name] = isNaN(value) || value == "" ? value : +value;
    trade[`error_${name}`] = false;
    trade.error = undefined;

    const totals = this.calcTotals(day);
    day.leftClientQtyToAssign = totals.leftClientQtyToAssign;
    day.leftPropQtyToAssign = totals.leftPropQtyToAssign;
    day.leftTradingQtyToAssign = totals.leftTradingQtyToAssign;
    day.leftErrorQtyToAssign = totals.leftErrorQtyToAssign;

    this.setState({
      days,
      error: undefined,
    });
  };

  validate = () => {
    const { days } = this.state;
    let hasErrors = false;
    let error;

    const modDays = days.map((day) => {
      const modDay = day;

      let totalAssignedClientQty = 0;
      let totalAssignedPropQty = 0;
      let totalAssignedTradingQty = 0;
      let totalAssignedErrorQty = 0;

      modDay.trades = day.trades.map((trade) => {
        const modTrade = trade;

        if (
          modTrade.assignedClientQty === undefined ||
          modTrade.assignedClientQty === "" ||
          modTrade.assignedClientQty < 0
        ) {
          modTrade.error_assignedClientQty = true;
          modTrade.error = "Required fields";
          hasErrors = true;
        }
        if (
          modTrade.assignedPropQty === undefined ||
          modTrade.assignedPropQty === "" ||
          modTrade.assignedPropQty < 0
        ) {
          modTrade.error_assignedPropQty = true;
          modTrade.error = "Required fields";
          hasErrors = true;
        }
        if (
          modTrade.assignedTradingQty === undefined ||
          modTrade.assignedTradingQty === "" ||
          modTrade.assignedTradingQty < 0
        ) {
          modTrade.error_assignedTradingQty = true;
          modTrade.error = "Required fields";
          hasErrors = true;
        }
        if (
          modTrade.assignedErrorQty === undefined ||
          modTrade.assignedErrorQty === "" ||
          modTrade.assignedErrorQty < 0
        ) {
          modTrade.error_assignedErrorQty = true;
          modTrade.error = "Required fields";
          hasErrors = true;
        }

        if (
          modTrade.assignedClientQty +
            modTrade.assignedPropQty +
            modTrade.assignedTradingQty +
            modTrade.assignedErrorQty !==
          modTrade.quantity
        ) {
          modTrade.error = "Quantity assigned is different than trade qty";
          hasErrors = true;
        }

        totalAssignedClientQty += modTrade.assignedClientQty;
        totalAssignedPropQty += modTrade.assignedPropQty;
        totalAssignedTradingQty += modTrade.assignedTradingQty;
        totalAssignedErrorQty += modTrade.assignedErrorQty;

        return modTrade;
      });

      if (totalAssignedClientQty !== modDay.clientQtyToAssign) {
        error = "There are client leftovers";
        hasErrors = true;
      } else if (totalAssignedPropQty !== modDay.propQtyToAssign) {
        error = "There are prop leftovers";
        hasErrors = true;
      } else if (totalAssignedTradingQty !== modDay.tradingQtyToAssign) {
        error = "There are trading leftovers";
        hasErrors = true;
      } else if (totalAssignedErrorQty !== modDay.errorQtyToAssign) {
        error = "There are error leftovers";
        hasErrors = true;
      }

      return modDay;
    });

    this.setState({
      days: modDays,
      error,
    });

    return !hasErrors;
  };

  onAssignmentUpdate = () => {
    if (this.validate()) {
      const { order } = this.props;
      const { info, days } = this.state;
      const { fetchUpdateOrderQuantityToTradesAssignment, onToggle } = this.props;

      const daysToSend = days.map((day) => ({
        Date: day.date,
        Trades: day.trades.map((trade) => ({
          TradeId: trade.tradeId,
          AssignedClientQuantity: trade.assignedClientQty,
          AssignedPropQuantity: trade.assignedPropQty,
          AssignedTradingQuantity: trade.assignedTradingQty,
          AssignedErrorQuantity: trade.assignedErrorQty,
        })),
      }));

      this.setState({ confirm: { loading: true } });

      fetchUpdateOrderQuantityToTradesAssignment({
        orderId: order.OrderId,
        QuantityToTradesAssignment: {
          CurrentVersion: info.currentOrderVersion,
          Day: daysToSend,
        },
      }).then((res) => {
        onToggle();
      });
    }
  };

  calcTotals = (day) => {
    const totals = {
      leftClientQtyToAssign: 0,
      leftPropQtyToAssign: 0,
      leftTradingQtyToAssign: 0,
      leftErrorQtyToAssign: 0,
    };

    let totalAssignedClientQuantity = 0;
    let totalAssignedPropQuantity = 0;
    let totalAssignedTradingQuantity = 0;
    let totalAssignedErrorQuantity = 0;

    day.trades.forEach((trade) => {
      if (!isNaN(trade.assignedClientQty)) {
        totalAssignedClientQuantity += trade.assignedClientQty;
      }
      if (!isNaN(trade.assignedPropQty)) {
        totalAssignedPropQuantity += trade.assignedPropQty;
      }
      if (!isNaN(trade.assignedTradingQty)) {
        totalAssignedTradingQuantity += trade.assignedTradingQty;
      }
      if (!isNaN(trade.assignedErrorQty)) {
        totalAssignedErrorQuantity += trade.assignedErrorQty;
      }
    });

    totals.leftClientQtyToAssign = day.clientQtyToAssign - totalAssignedClientQuantity;
    totals.leftPropQtyToAssign = day.propQtyToAssign - totalAssignedPropQuantity;
    totals.leftTradingQtyToAssign = day.tradingQtyToAssign - totalAssignedTradingQuantity;
    totals.leftErrorQtyToAssign = day.errorQtyToAssign - totalAssignedErrorQuantity;

    return totals;
  };

  render() {
    const { open, order } = this.props;
    const { selectedDate, days, confirm, error } = this.state;

    if (!selectedDate || !days) {
      return (
        <Modal isOpen={open} toggle={this.onToggle} className={style.modal}>
          <ModalHeader toggle={this.onToggle}>
            Quantity to trades assignment
            <OrderInlineDetail order={order} />
          </ModalHeader>
        </Modal>
      );
    }

    const listOfDays = days ? days.map((d) => ({ id: d.date, description: d.date })) : [];
    const selectedDateDay = days ? days.find((d) => d.date === selectedDate) : {};
    const { trades } = selectedDateDay;

    return (
      <Modal isOpen={open} toggle={this.onToggle} className={style.modal}>
        <ModalHeader toggle={this.onToggle}>
          Quantity to trades assignment
          <OrderInlineDetail order={order} />
        </ModalHeader>
        <ModalBody style={{ padding: "10px 15px", minHeight: "225px" }}>
          <div className={style.distributionType}>
            <label>Date</label>
            <Combobox
              value={selectedDate}
              items={listOfDays}
              onChange={(v) => this.setState({ selectedDate: v })}
              emptyLabel="Date"
              invalid={!!error}
              style={{ minWidth: "180px", marginRight: "10px" }}
            />
          </div>
          {trades &&
            trades.map((t) => (
              <ItemRow
                trade={t}
                dayInfo={selectedDateDay}
                id={t.tradeId}
                key={`irow-${t.tradeId}`}
                enabled={t.enabled}
                actions={{
                  change: this.changeItem,
                }}
              />
            ))}

          {error && (
            <Fragment>
              <hr />
              <Alert color="danger" className={style.alert}>
                {error}
              </Alert>
            </Fragment>
          )}
        </ModalBody>

        <ModalFooter style={{ padding: "12px 20px" }}>
          <FooterTotals totals={selectedDateDay} />

          <Button color="light" onClick={this.onToggle}>
            Close
          </Button>
          <LaddaButton
            className={classnames("btn btn-ladda", style.update)}
            loading={confirm.loading}
            onClick={this.onAssignmentUpdate}
            data-style={EXPAND_RIGHT}
          >
            Update
          </LaddaButton>
        </ModalFooter>
      </Modal>
    );
  }
}

const Number = ({ value, dataTypeDecimalName }) => {
  if (value === null) {
    return "-";
  }

  return <FormattedNumber value={value} dataTypeDecimalName={dataTypeDecimalName} />;
};

const FooterTotals = ({ totals }) => (
  <div className={style.footerTotals}>
    <div style={{ marginRight: "40px", minWidth: "240px" }}>
      <table style={{ margin: "10px 0px" }}>
        <tbody>
          {totals.clientQtyToAssign > 0 && (
            <tr>
              <td>Client quantity</td>
              <td>
                <Number value={totals.clientQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.propQtyToAssign > 0 && (
            <tr>
              <td>Prop quantity</td>
              <td>
                <Number value={totals.propQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.tradingQtyToAssign > 0 && (
            <tr>
              <td>Trading quantity</td>
              <td>
                <Number value={totals.tradingQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.errorQtyToAssign > 0 && (
            <tr>
              <td>Error quantity</td>
              <td>
                <Number value={totals.errorQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    <div>
      <strong>Leftovers</strong>
      <table>
        <tbody>
          {totals.clientQtyToAssign > 0 && (
            <tr>
              <td style={{ color: "#4dbd74", fontWeight: 500 }}>Client qty</td>
              <td>
                <Number value={totals.leftClientQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.propQtyToAssign > 0 && (
            <tr>
              <td style={{ color: "#4dbd74", fontWeight: 500 }}>Prop qty</td>
              <td>
                <Number value={totals.leftPropQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.tradingQtyToAssign > 0 && (
            <tr>
              <td style={{ color: "#4dbd74", fontWeight: 500 }}>Trading qty</td>
              <td>
                <Number value={totals.leftTradingQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
          {totals.errorQtyToAssign > 0 && (
            <tr>
              <td style={{ color: "#4dbd74", fontWeight: 500 }}>Error qty</td>
              <td>
                <Number value={totals.leftErrorQtyToAssign} dataTypeDecimalName="quantity" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default OrderQuantityToTradesAssignment;
